var _sodipodiNamedview, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorph3DbotLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    viewBox: "0 0 886.88555 205.59527",
    sodipodiDocname: "morph3dbot_logo_white.svg",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview39",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapeZoom: 1.3598147,
    inkscapeCx: 566.25363,
    inkscapeCy: 97.807446,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "logo"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\r\n      .st0 {\r\n        fill: #265aa6;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #df7e00;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #df342c;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #f9b122;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #bb101b;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #123068;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.78326,102.33387l-37.84412-19.34932-9.17654-4.69348c-6.09337-3.11324-13.26455,1.41706-13.26455,8.38213v53.73238c0,5.67254,3.01018,10.89849,7.85825,13.65531l47.25684,26.84258c6.10624,3.47395,13.61237-1.04347,13.61237-8.1889v-56.41191c0-5.9173-3.26783-11.3236-8.44225-13.96879",
    id: "path6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.66024,51.57517l-52.3325-26.75668c-3.4396-1.76059-7.48895-1.76059-10.92855,0l-52.33679,26.75668c-4.50024,2.30166-4.50024,8.87166,0,11.17332l12.01496,6.14489,40.32183,20.61179c3.4396,1.76059,7.48895,1.76059,10.92855,0l40.38194-20.64614,11.95055-6.11054c4.50454-2.30166,4.50454-8.87166,0-11.17332",
    id: "path8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.96304,78.29235l-9.05202,4.62907-37.96864,19.41374c-5.17442,2.64518-8.44225,8.05148-8.44225,13.96878v56.41191c0,7.14113,7.50613,11.65855,13.61237,8.18889l47.25684-26.84687c4.84806-2.75253,7.85395-7.97848,7.85395-13.65102v-53.73237c0-6.96507-7.16689-11.49537-13.26025-8.38214",
    id: "path10"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.61237,128.58557c-1.22813,2.23295-3.12183,2.90283-4.90819,2.90283s-3.57271-.66988-4.80083-2.90283l-12.83084-24.10292v48.87572c0,3.01448-3.68007,4.57324-7.25279,4.57324-3.68006,0-7.25277-1.55877-7.25277-4.57324v-69.74087c0-5.35477,3.57271-7.25277,7.25277-7.25277,5.24313,0,7.58773,1.11647,11.27208,7.69936l13.72403,24.9961,13.72402-24.9961c3.68435-6.58289,6.13631-7.69936,11.37944-7.69936,3.68435,0,7.25277,1.898,7.25277,7.25277v69.74087c0,3.01448-3.68007,4.57324-7.25277,4.57324-3.68007,0-7.25279-1.55877-7.25279-4.57324v-47.98254l-13.05413,23.20974Z",
    id: "path12",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.29507,101.91777c0-8.81584-4.4616-12.83084-11.71436-12.83084-7.36444,0-11.60703,4.015-11.60703,12.83084v31.1324c0,8.81154,4.24259,12.83084,11.60703,12.83084,7.25276,0,11.71436-4.0193,11.71436-12.83084v-31.1324ZM291.46815,133.05017v-31.1324c0-18.6322,11.38371-25.55434,26.11256-25.55434s26.21994,6.92213,26.21994,25.55434v31.1324c0,18.63221-11.49109,25.55004-26.21994,25.55004s-26.11256-6.91783-26.11256-25.55004",
    id: "path14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373.48938,89.08607v23.76798h12.27261c7.25705,0,11.94195-3.01447,11.94195-11.83031s-4.6849-11.93767-11.94195-11.93767h-12.27261ZM358.98383,80.82847c0-2.34459,1.89798-4.46159,4.68487-4.46159h22.09329c14.62149,0,26.4475,5.57807,26.4475,23.32139,0,12.83085-6.24796,19.74868-14.6172,22.31656l14.6172,27.1131c.44657.55824.55822,1.33977.55822,1.78636,0,3.68007-4.80081,7.58772-9.03911,7.58772-2.00966,0-3.90338-1.22812-5.01983-3.46106l-15.84533-30.79746h-9.37407v29.12275c0,3.01447-3.56842,4.57754-7.25279,4.57754-3.56842,0-7.25276-1.56306-7.25276-4.57754v-72.52776Z",
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.88856,89.08607v27.00145h12.49588c7.25279,0,11.71868-4.12666,11.71868-12.83084v-1.33977c0-8.70419-4.46589-12.83085-11.71868-12.83085h-12.49588ZM425.38302,80.82847c0-2.34459,2.12128-4.46159,5.4664-4.46159h22.42821c14.17062,0,25.33105,6.80619,25.33105,25.10345v.66988c0,18.30155-11.49538,25.33104-26.22423,25.33104h-12.49588v25.88498c0,3.01447-3.68007,4.57754-7.25279,4.57754-3.68437,0-7.25276-1.56306-7.25276-4.57754v-72.52776Z",
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529.94366,121.33365h-25.10775v32.02558c0,3.01018-3.68007,4.57324-7.25279,4.57324-3.68007,0-7.25279-1.56306-7.25279-4.57324v-72.53205c0-3.12183,3.57271-4.4616,7.25279-4.4616,3.57271,0,7.25279,1.33977,7.25279,4.4616v29.12704h25.10775v-29.12704c0-3.12183,3.57268-4.4616,7.25276-4.4616,3.57271,0,7.25279,1.33977,7.25279,4.4616v72.53205c0,3.01018-3.68007,4.57324-7.25279,4.57324-3.68007,0-7.25276-1.56306-7.25276-4.57324v-32.02558Z",
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M596.78984,135.39347v-2.1213c0-10.70955-6.58291-15.84532-16.85019-15.84532-1.67038,0-2.45194-1.33547-2.45194-2.56359,0-1.33976.78156-2.56788,2.34029-2.56788,9.82067,0,14.95218-3.79171,14.95218-15.17544,0-10.26725-4.34995-15.51038-14.50558-15.51038-12.83084,0-15.28707,8.14595-15.28707,13.05414,0,1.898-.89318,3.12612-2.79115,3.12612-2.00537,0-2.7869-.89318-2.7869-3.796,0-5.68972,3.68004-17.62739,21.20008-17.62739,11.71436,0,19.63702,5.24313,19.63702,19.52539,0,10.49055-4.2383,16.51521-9.25816,18.97144,6.58291,2.78689,11.37947,8.36925,11.37947,18.40891v2.1213c0,16.85015-10.04398,23.20974-22.42824,23.20974-15.28704,0-22.53983-9.82066-22.53983-17.96661,0-2.67524.89318-3.45677,2.56788-3.45677,2.22867,0,2.89855,1.22382,2.89855,2.67524,0,4.68918,3.23776,13.39337,16.73844,13.39337,10.93719,0,17.18515-5.58236,17.18515-17.85497",
    id: "path22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.68959,81.72036v70.85734h16.85019c10.60217,0,16.96178-5.694,16.96178-18.07826v-34.70082c0-12.38855-6.35961-18.07826-16.96178-18.07826h-16.85019ZM641.53979,76.36558c12.61183,0,22.53983,6.3596,22.53983,23.43304v34.70082c0,17.07344-9.928,23.43304-22.53983,23.43304h-19.74874c-1.56305,0-2.6795-1.11647-2.6795-2.3446v-76.8777c0-1.22812,1.11645-2.3446,2.6795-2.3446h19.74874Z",
    id: "path24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M708.61006,145.20898c6.80622,0,10.82121-3.68007,10.82121-12.16096v-1.78206c0-8.70419-4.015-11.83031-10.82121-11.83031h-12.61183v25.77333h12.61183ZM695.99823,108.05622h12.49592c6.02891,0,8.92746-3.90765,8.92746-9.59737,0-5.80136-3.34509-9.37407-9.03479-9.37407h-12.38859v18.97144ZM681.60437,80.93882c0-3.01017,3.12611-4.57324,6.35954-4.57324h21.53503c11.60703,0,22.4325,3.79171,22.4325,19.63703,0,9.15077-3.57271,15.17543-9.48572,17.74332,6.80622,2.67524,11.49112,7.02948,11.49112,18.18562v2.34459c0,17.40838-9.70902,23.65633-22.31659,23.65633h-23.65634c-3.90334,0-6.35954-2.1213-6.35954-4.46159v-72.53206Z",
    id: "path26",
    style: {
      fill: "#c1c1c1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M784.04586,101.91777c0-8.81584-4.46586-12.83084-11.71868-12.83084-7.36441,0-11.60271,4.015-11.60271,12.83084v31.1324c0,8.81154,4.2383,12.83084,11.60271,12.83084,7.25282,0,11.71868-4.0193,11.71868-12.83084v-31.1324ZM746.21896,133.05017v-31.1324c0-18.6322,11.3794-25.55434,26.10822-25.55434s26.22426,6.92213,26.22426,25.55434v31.1324c0,18.63221-11.49538,25.55004-26.22426,25.55004s-26.10822-6.91783-26.10822-25.55004",
    id: "path28",
    style: {
      fill: "#c3c3c3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M858.81432,76.36558c3.12611,0,4.57319,3.34942,4.57319,6.47125,0,3.46107-1.67038,6.5829-4.57319,6.5829h-16.29194v63.93951c0,3.01447-3.68004,4.57324-7.25276,4.57324-3.68437,0-7.25282-1.55877-7.25282-4.57324v-63.93951h-16.40352c-2.90287,0-4.57325-3.01447-4.57325-6.5829,0-3.12183,1.44714-6.47125,4.57325-6.47125h47.20103Z",
    id: "path30",
    style: {
      fill: "#d0d0d0",
      fillOpacity: 1
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.91275,132.47261v-49.5542l-37.97294,19.41374c-5.17442,2.64519-8.44225,8.05578-8.44225,13.96879v46.7759l42.48606-23.77657c2.42618-1.37841,3.92913-3.99353,3.92913-6.82766",
    id: "path32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.78326,102.33387l-37.84412-19.34932v49.48978c0,2.83412,1.50294,5.44495,3.92912,6.82336l42.35724,23.77227v-46.76731c0-5.9173-3.26783-11.3236-8.44225-13.96879",
    id: "path34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.32602,89.50732l40.38623-20.65044-43.05289-22.01168c-1.72195-.876-3.74448-.876-5.46642,0l-43.1173,22.04604,40.32183,20.61609c3.43959,1.7606,7.48895,1.7606,10.92855,0",
    id: "path36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorph3DbotLogoWhite);
export default __webpack_public_path__ + "static/media/morph3dbot_logo_white.efb2723c84ce6260228d76e24d3f0e66.svg";
export { ForwardRef as ReactComponent };